if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const { isSetUpQuizAdd } = window;
        window.isSetUpQuizAdd = isSetUpQuizAdd || true;
        if (!isSetUpQuizAdd && !this.form) {
          this.setQuizAdd();
          return;
        } else if (!this.form) return;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.getElementById('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.getElementById('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /**
       * The setQuizDiscount method is a special method of a class for set
       * quiz discount to cart.
       * @name setQuizDiscount
       * @kind function
       * @param {string} discount The quiz discount.
       * @param {HTMLElement} cart The cart drawer element.
       * @returns {null|boolean} The method returns true only when the
       * discount is applied to the cart. For other 'null' or 'false' when
       * the code doesn't exist or the cart item has a discount.
       */
      async setQuizDiscount(discount, cart) {
        if (!discount || !cart) return null;
        const quizDiscount = `${discount}`.replace('/discount/', '');
        const cartData = cart.querySelector('script[cart-data]').innerHTML;
        const cartItemHasQuizDiscount = ((JSON.parse(cartData) || {items: []}).items || [])
          .find((i) => i.discounts.find(d => {
            console.log(d.title.toUpperCase(), quizDiscount.toUpperCase());
            return d.title.toUpperCase() === quizDiscount.toUpperCase();
          }));
        
        if (cartItemHasQuizDiscount) return false;
        await fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount: quizDiscount })
        });
        return true;
      }

      /**
       * The setQuizAdd method is a special method of a class for set
       * quiz option 'add to cart' and append discount code.
       * @name setQuizAdd
       * @kind function
       */
      setQuizAdd() {
        window.addEventListener('message', (event) => {
          (async () => {
            const {items, discount} = event.data;
            if (!items) return;
            const cart = document.getElementById('cart-drawer');
            await this.setQuizDiscount(discount, cart);

            const form = document.createElement('form');
            const inputId = document.createElement('input');
            inputId.name = 'id';
            inputId.value = items[0].id;
            const inputQuantity = document.createElement('input');
            inputQuantity.name = 'quantity';
            inputQuantity.value = items[0].quantity;
            const button = document.createElement('button');
            button.setAttribute('aria-disabled', false);
            button.classList.add('loading-overlay__spinner');
            form.insertAdjacentElement('afterbegin', button);
            form.insertAdjacentElement('afterbegin', inputQuantity);
            form.insertAdjacentElement('afterbegin', inputId);
            const productForm = document.createElement('product-form');
            productForm.insertAdjacentElement('afterbegin', form);
            productForm.form = form;
            productForm.submitButton = button;
            productForm.cart = cart;
            productForm.onSubmitHandler();
          })();
        });
      }

      onSubmitHandler(evt) {
        if (evt) evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          try {
            const c = p => document.cookie.split('; ').find(r => r.startsWith(p))?.split('=')[1] || '';
            formData.append('attributes[_client_id]', c('_ga=').slice(6));
            formData.append('attributes[_session_id]', c('_ga_S').split('$')[0].slice(7));
          } catch (error) {}
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          // this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(() => publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id')
          }))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        document.querySelectorAll(`[product-alert='${this.form.getAttribute('id')}']`)
          .forEach((wrapper) => {
            const messageElement = wrapper.querySelector('small');
            wrapper.setAttribute('aria-hidden', `${!errorMessage}`);

            if (!errorMessage || !messageElement) return;
            messageElement.textContent = errorMessage;
          });
      }
    }
  );
  document.createElement('product-form');
}
